var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 218.839,
    height: 150.319,
    viewBox: "0 0 218.839 150.319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58348",
    "data-name": "Group 58348",
    transform: "translate(-377.93 -297.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42278",
    "data-name": "Path 42278",
    d: "M1733.064-878.876s-63-8.875-53.073-53.072,59.706-38.218,59.706-38.218,1.256-60.445,58.57-59,56.009,60.664,56.009,60.664,38.352,10.911,42.666,38.327-8.5,45.32-32.952,51.3C1804.62-879.38,1733.064-878.876,1733.064-878.876Z",
    transform: "translate(-1301 1327)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "undraw_login_re_4vu2",
    transform: "translate(384.642 324.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42259",
    "data-name": "Path 42259",
    d: "M818.543,576.857a10.578,10.578,0,0,1-3.8-9.119,8.551,8.551,0,0,1,6.358-7.26,7.2,7.2,0,0,1,8.2,4.555c.561-6.317,1.207-12.9,4.565-18.278a19.358,19.358,0,0,1,14.017-8.98,17.368,17.368,0,0,1,15.279,6.237,15.763,15.763,0,0,1,1.938,16.229c-1.837,3.811-5.221,6.647-8.767,8.954a56.58,56.58,0,0,1-38.7,8.466Z",
    transform: "translate(-661.808 -455.85)",
    fill: "#00b248"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42260",
    "data-name": "Path 42260",
    d: "M907.445,545.588a93.359,93.359,0,0,0-27.431,37.093c-.262.641.779.92,1.038.286a92.32,92.32,0,0,1,27.155-36.618C908.744,545.911,907.978,545.154,907.445,545.588Z",
    transform: "translate(-711.736 -461.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42261",
    "data-name": "Path 42261",
    d: "M230.9,526.742a14.529,14.529,0,0,0,5.213-12.525,11.745,11.745,0,0,0-8.732-9.972c-4.607-.993-9.859,1.756-11.258,6.257-.77-8.677-1.658-17.717-6.271-25.105A26.588,26.588,0,0,0,190.6,473.062a23.856,23.856,0,0,0-20.986,8.567,21.65,21.65,0,0,0-2.662,22.29c2.523,5.234,7.171,9.129,12.041,12.3a77.712,77.712,0,0,0,53.15,11.628",
    transform: "translate(-165 -406.336)",
    fill: "#67b200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42262",
    "data-name": "Path 42262",
    d: "M213.351,483.793a127.148,127.148,0,0,1,17.719,17.6,127.521,127.521,0,0,1,19.958,33.351c.359.881-1.071,1.264-1.426.393a126.8,126.8,0,0,0-37.3-50.294c-.738-.6.313-1.642,1.046-1.046Z",
    transform: "translate(-200.982 -414.51)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42263",
    "data-name": "Path 42263",
    d: "M510.386,312.054H424.5V223.932a34.04,34.04,0,0,1,34-34h17.883a34.04,34.04,0,0,1,34,34Z",
    transform: "translate(-363.438 -189.931)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42264",
    "data-name": "Path 42264",
    d: "M492.5,312.057h-68V223.935a33.738,33.738,0,0,1,6.493-19.988c.156-.213.312-.423.473-.631a33.993,33.993,0,0,1,7.237-7.024c.155-.113.311-.224.469-.335a33.921,33.921,0,0,1,7.406-3.873c.155-.059.314-.118.472-.175a33.889,33.889,0,0,1,7.32-1.726c.155-.021.314-.038.473-.054a34.421,34.421,0,0,1,7.319,0c.158.017.317.033.474.054a33.883,33.883,0,0,1,7.318,1.726c.158.057.317.116.473.175a33.837,33.837,0,0,1,7.319,3.816c.158.109.316.22.472.331a34.354,34.354,0,0,1,4.326,3.662,33.95,33.95,0,0,1,2.994,3.424c.16.207.316.417.472.63a33.738,33.738,0,0,1,6.494,19.988Z",
    transform: "translate(-363.438 -189.934)",
    fill: "#3ea598"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_500",
    "data-name": "Ellipse 500",
    cx: 3.765,
    cy: 3.765,
    r: 3.765,
    transform: "translate(119.77 75.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42265",
    "data-name": "Path 42265",
    d: "M580.763,471.622h-2.885l-1.373-11.127h4.258Z",
    transform: "translate(-440.851 -352.138)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42266",
    "data-name": "Path 42266",
    d: "M562.2,504.28h5.563v3.5h-9.066A3.5,3.5,0,0,1,562.2,504.28Z",
    transform: "translate(-427.231 -385.62)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42267",
    "data-name": "Path 42267",
    d: "M641.763,471.622h-2.885l-1.373-11.127h4.258Z",
    transform: "translate(-487.498 -352.138)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42268",
    "data-name": "Path 42268",
    d: "M623.2,504.28h5.564v3.5h-9.066A3.5,3.5,0,0,1,623.2,504.28Z",
    transform: "translate(-473.877 -385.62)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42269",
    "data-name": "Path 42269",
    d: "M696.68,428.647a2.528,2.528,0,0,1,1.061-3.728l9.807-27.029,4.825,2.633-11.2,25.83a2.542,2.542,0,0,1-4.5,2.294Z",
    transform: "translate(-571.239 -348.957)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42270",
    "data-name": "Path 42270",
    d: "M802.251,444.866a2.528,2.528,0,0,1-.681-3.816l-3.038-28.592,5.491.251,1.263,28.124a2.542,2.542,0,0,1-3.035,4.033Z",
    transform: "translate(-649.459 -360.096)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_501",
    "data-name": "Ellipse 501",
    cx: 5.779,
    cy: 5.779,
    r: 5.779,
    transform: "translate(138.252 32.369)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42271",
    "data-name": "Path 42271",
    d: "M757.556,417.882H740.133l.021-.136c.031-.2,3.105-20.34.838-26.927a2.78,2.78,0,0,1,1.428-3.432h0c3.241-1.526,9.461-3.405,14.711,1.155a6.644,6.644,0,0,1,2.226,5.505Z",
    transform: "translate(-604.801 -339.615)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42272",
    "data-name": "Path 42272",
    d: "M728.862,406.662l-7.844-1.591,3.677-8.713A3.294,3.294,0,0,1,731.073,398Z",
    transform: "translate(-590.184 -345.895)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42273",
    "data-name": "Path 42273",
    d: "M795.308,411.6l-.472-10.81a3.323,3.323,0,1,1,6.491-1.124l1.773,10.1Z",
    transform: "translate(-646.583 -347.876)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42274",
    "data-name": "Path 42274",
    d: "M753.926,517.049c2.8,10.677,3.109,24.253,2.353,39.061l-3.765-.471L745.691,527.4l-3.765,28.707-4.235-.235c-1.265-15.537-2.5-28.875-.471-37.649Z",
    transform: "translate(-601.751 -440.077)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42275",
    "data-name": "Path 42275",
    d: "M758.365,329.082a1.867,1.867,0,0,1-3.221-1.037,1.9,1.9,0,0,1,0-.366,8.488,8.488,0,0,0,.378-2.06,1.081,1.081,0,0,0-.2-.506c-.859-1.15-2.876.515-3.687-.527-.5-.639.087-1.644-.294-2.358-.5-.942-2-.477-2.93-.993-1.041-.574-.978-2.171-.293-3.142a4.942,4.942,0,0,1,3.747-1.908,10.051,10.051,0,0,1,4.234.826,8.46,8.46,0,0,1,4,2.774,6.771,6.771,0,0,1,.685,5.765A10.868,10.868,0,0,1,758.365,329.082Z",
    transform: "translate(-610.525 -286.467)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42276",
    "data-name": "Path 42276",
    d: "M439.5,707.193H265.777c-.155,0-.28.342-.28.763s.125.763.28.763H439.5c.155,0,.28-.342.28-.763S439.656,707.193,439.5,707.193Z",
    transform: "translate(-241.85 -585.213)",
    fill: "#3ea598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42277",
    "data-name": "Path 42277",
    d: "M529.619,368.728h-30.59a1.521,1.521,0,0,1-1.53-1.51V298.94a1.521,1.521,0,0,1,1.529-1.51h30.59a1.521,1.521,0,0,1,1.529,1.51v68.278A1.521,1.521,0,0,1,529.619,368.728Z",
    transform: "translate(-419.261 -272.135)",
    fill: "#349084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_69",
    "data-name": "Union 69",
    d: "M-1663.288,1073.915V1051.8h-11.3v22.119h-.471V1051.8h-10.471v-.471h10.471v-26.38h-10.589v-.471h10.589v-22.092h.471v22.092h11.3v-22.092h.471v22.092h10.824v.471h-10.824v26.38h10.941v.471h-10.941v22.119Zm0-22.59v-26.38h-11.3v26.38Z",
    transform: "translate(1763.881 -977.087)",
    fill: "#3ea598"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_24",
    "data-name": "Polygon 24",
    transform: "translate(412.697 331.947) rotate(-31)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6 10.64963531494141 L 4.754459857940674 7.52485990524292 L 4.674849987030029 7.325150012969971 L 4.47514009475708 7.245540142059326 L 1.350364208221436 6 L 4.47514009475708 4.754459857940674 L 4.674849987030029 4.674849987030029 L 4.754459857940674 4.47514009475708 L 6 1.350364208221436 L 7.245540142059326 4.47514009475708 L 7.325150012969971 4.674849987030029 L 7.52485990524292 4.754459857940674 L 10.64963531494141 6 L 7.52485990524292 7.245540142059326 L 7.325150012969971 7.325150012969971 L 7.245540142059326 7.52485990524292 L 6 10.64963531494141 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6 2.700718879699707 L 5.059710025787354 5.059710025787354 L 2.700718879699707 6 L 5.059710025787354 6.940289974212646 L 6 9.299282073974609 L 6.940289974212646 6.940289974212646 L 9.299282073974609 6 L 6.940289974212646 5.059710025787354 L 6 2.700718879699707 M 6 0 L 7.710000038146973 4.289999961853027 L 12 6 L 7.710000038146973 7.710000038146973 L 6 12 L 4.289999961853027 7.710000038146973 L 0 6 L 4.289999961853027 4.289999961853027 L 6 0 Z",
    stroke: "none",
    fill: "#3ea598"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_25",
    "data-name": "Polygon 25",
    d: "M3,0l.855,2.145L6,3l-2.145.855L3,6,2.145,3.855,0,3l2.145-.855Z",
    transform: "translate(418.13 319.718) rotate(-31)",
    fill: "#3ea598"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_509",
    "data-name": "Ellipse 509",
    transform: "translate(562.93 344)",
    fill: "#f3f7f8",
    stroke: "#8cce32",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_58377",
    "data-name": "Group 58377",
    transform: "translate(-21.07 2)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_734",
    "data-name": "Line 734",
    x2: 3.784,
    transform: "translate(585.608 324.5)",
    fill: "none",
    stroke: "#f55",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_735",
    "data-name": "Line 735",
    y2: 3.784,
    transform: "translate(587.5 322.608)",
    fill: "none",
    stroke: "#f55",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.82036adfa4a14b384b76ffc590fe5bb4.svg";
export { ForwardRef as ReactComponent };